export const VendorDetailActiveOffersPageSize = 6;
